<script>
  import { emitter } from '@/main.js';

  export default {
    name: 'CollectionSeeMore',
    data() {
      return {
        page: 0,
        pageCount: 0,
        loading: false,
        buttonText: '',
        loadingText: '',
        buttonStyle: '',
        buttonColor: '',
        buttonTextColor: '',
        outlineBlur: 0,
        enableGlow: false,
        glowLevel: 0,
        glowColor: '',
        glowHoverColor: '',
        isHovered: false
      };
    },
    computed: {
      hasMorePages() {
        return this.page < this.pageCount;
      },
      buttonClasses() {
        return `${this.buttonStyle} gt-btn`;
      },
      buttonStyles() {
        const styles = {};
        if (this.buttonTextColor) {
          styles.color = this.buttonTextColor;
          styles['text-decoration-color'] = this.buttonTextColor;
        }
        if (this.buttonStyle === 'btn' || this.buttonStyle === 'btn--soft') {
          styles['background-color'] = this.buttonColor;
          styles['border-color'] = this.buttonColor;
        } else if (this.buttonStyle === 'btn--outline') {
          styles['border-color'] = this.buttonColor;
          styles['backdrop-filter'] = `blur(${this.outlineBlur}px)`;
          styles['-webkit-backdrop-filter'] = `blur(${this.outlineBlur}px)`;
        }
        if (this.enableGlow && (this.buttonStyle === 'btn' || this.buttonStyle === 'btn--outline')) {
          const glowColor = this.isHovered ? this.glowHoverColor : this.glowColor;
          const level = this.isHovered ? this.glowLevel + 4 : this.glowLevel;
          styles['box-shadow'] = `0 0 ${level}px ${glowColor}`;
        }
        return styles;
      }
    },
    mounted() {
      const el = this.$el.parentElement;
      this.buttonText = el.getAttribute('data-see-more-text');
      this.loadingText = el.getAttribute('data-see-more-loading-text');
      this.buttonStyle = el.getAttribute('data-button-style');
      this.buttonColor = el.getAttribute('data-button-color');
      this.buttonTextColor = el.getAttribute('data-button-text-color');
      this.outlineBlur = parseInt(el.getAttribute('data-outline-blur'));
      this.enableGlow = el.getAttribute('data-enable-glow') === 'true';
      this.glowLevel = parseInt(el.getAttribute('data-glow-level'));
      this.glowColor = el.getAttribute('data-glow-color');
      this.glowHoverColor = el.getAttribute('data-glow-hover-color');

      this.pagerHandler = e => {
        this.pageCount = e.pageCount;
        this.page = e.page;
        this.loading = false;
      };
      emitter.on('fs-update-pager', this.pagerHandler);
    },
    beforeUnmount() {
      emitter.off('fs-update-pager', this.pagerHandler);
    },
    methods: {
      loadMore() {
        if (this.loading || !this.hasMorePages) return;
        this.loading = true;
        emitter.emit('fs-update-page', this.page + 1);
      }
    }
  };
</script>

<template>
  <div class="collection-see-more" v-if="hasMorePages">
    <button :class="buttonClasses" :style="buttonStyles" :disabled="loading" @click="loadMore" @mouseenter="isHovered = true" @mouseleave="isHovered = false">
      {{ loading ? loadingText : buttonText }}
    </button>
  </div>
</template>

<style scoped>
  .collection-see-more {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem 0;
    width: 100%;
  }
</style>
